import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=d04db314"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports